import { z } from "zod";

const featureLimitedSchema = z.object({
  max: z.number().optional(),
  errorMessage: z.string(),
  errorReason: z.string(),
});

const featureToggleSchema = z.object({
  enabled: z.boolean(),
  errorMessage: z.string(),
  errorReason: z.string(),
});

const featureWithImportJobsSchema = featureLimitedSchema.extend({
  noImportJobsErrorMessage: z.string(),
  noImportJobsErrorReason: z.string(),
});

export const FeaturesSummary = z.object({
  designSystems: featureLimitedSchema,
  designSystemSources: featureWithImportJobsSchema,
  designSystemVersions: featureLimitedSchema,
  themes: featureLimitedSchema,
  brands: featureLimitedSchema,
  codegenSchedules: featureLimitedSchema,
  publicDocumentation: featureToggleSchema,
  customDocumentationUrl: featureToggleSchema,
  customDocumentationViewButton: featureToggleSchema,
  designSystemSourceAutoImport: featureToggleSchema,
  designSystemSlug: featureToggleSchema,
  ipWhitelisting: featureToggleSchema,
  npmRegistry: featureToggleSchema,
  sso: featureToggleSchema,
  workspacePaidSeats: featureLimitedSchema,
  workspaceViewers: featureLimitedSchema,
  customDocumentationExporter: featureToggleSchema,
  protectedPages: featureToggleSchema,
  approvals: featureToggleSchema,
  selectivePublishing: featureToggleSchema,
  designSystemAccessModes: featureToggleSchema,
  designSystemRoles: featureToggleSchema,
  documentationPageRedirects: featureToggleSchema,
  analytics: featureLimitedSchema,
  designSystemFileSize: featureLimitedSchema,
});

export type FeatureLimitedDetails = z.infer<typeof featureLimitedSchema>;
export type FeatureToggleDetails = z.infer<typeof featureToggleSchema>;
export type FeatureWithImportJobsDetails = z.infer<typeof featureWithImportJobsSchema>;
export type FeaturesSummary = z.infer<typeof FeaturesSummary>;
